import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export const schema = Joi.object().keys({
	name: Joi.string().required(),
	description: Joi.string().allow(''),
  permissions: Joi.array().required()
});

export default function registerPermissionGroup(schoolId, groupInfo) {
  if(!schoolId){
    throw 'Missing school ID'
  }

  let validateResult = Joi.validate(groupInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': `/group_list/${schoolId}/`,
		'method': 'POST',
		'data': JSON.stringify(groupInfo),
		'token': localStorage.getItem('token')})
		.then((res) => {
			resolve(res);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/permission/registerPermissionGroup.js